import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-settings-footer',
  templateUrl: './settings-footer.component.html',
  styleUrls: ['./settings-footer.component.scss']
})
export class SettingsFooterComponent implements OnInit {
  @Input() header: string;
  @Input() body: string;

  constructor() {}

  ngOnInit() {}
}
